/* eslint-disable no-nested-ternary */
import React from "react";
import PropTypes from "prop-types";

const day = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];

export default class TimeOfDay extends React.Component {
  abortController = new AbortController();

  constructor(props, context) {
    super(props, context);
    this.state = {
      loaded: false,
    };
  }

  componentDidMount = () => {
    fetch(`/services/getTodJSON?todId=${this.props.todId}`, {
      headers: {
        "content-type": "application/json",
      },
      method: "GET",
      credentials: "include",
      signal: this.abortController.signal,
    })
      .then((res) => res.json())
      .then((tod) => {
        const todResponse = tod.response.TodResponse;
        const timeOfDay = {};
        todResponse.forEach((x) => {
          // eslint-disable-next-line prefer-destructuring
          timeOfDay[x[0]] = x[1];
        });
        this.setState({ loaded: true, timeOfDay });
      });
  };

  componentWillUnmount = () => {
    this.abortController.abort();
  };

  formatTimeOfDay = (todData) => {
    const disp = day.map((o, i) => {
      const display = `${
        (todData.startHour[i] < 10 ? " 0" : " ") + todData.startHour[i]
      }:${todData.startMinute[i] < 10 ? "0" : ""}${todData.startMinute[i]} - ${
        todData.endHour[i] < 10 ? "0" : ""
      }${todData.endHour[i]}:${
        todData.endMinute[i] < 10 ? "0" : ""
      }${todData.endMinute[i]}`;

      return (
        <tr key={i} className={i % 2 > 0 ? "alt" : ""}>
          <td>{o}</td>
          <td>
            {todData.closed[i]
              ? " Closed"
              : todData.wholeDay[i]
                ? " All Day"
                : display}
          </td>
        </tr>
      );
    });
    return (
      <table>
        <tbody>{disp}</tbody>
      </table>
    );
  };

  render = () => {
    const { timeOfDay } = this.state;
    if (this.state.loaded) {
      if (timeOfDay.outOfHours) {
        return <span>Out Of Hours</span>;
      }
      return this.formatTimeOfDay(timeOfDay);
    }
    return (
      <span>
        <img src="/_client/images/global/ui-loader-1.gif" />
      </span>
    );
  };
}

TimeOfDay.propTypes = { todId: PropTypes.any };
